// src/pages/Audit.js
import React, { useEffect, useState } from 'react';
import { getAuditLogs } from '../services/api';
import { useAuth } from '../context/AuthContext';
import { T, Card, Empty, Spinner, SectionTitle, TH, TD, InfoBox } from '../components/UI';

export default function Audit() {
  const { can } = useAuth();
  const [logs, setLogs]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!can('view_audit')) { setLoading(false); return; }
    getAuditLogs()
      .then(r => setLogs(r.data.data))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [can]);

  if (!can('view_audit')) return (
    <div>
      <SectionTitle>Audit Trail</SectionTitle>
      <InfoBox variant="warning">⚠ Full audit trail is visible to Management only (Gachuki W).</InfoBox>
    </div>
  );

  if (loading) return <Spinner />;

  return (
    <div>
      <SectionTitle sub="Complete system log · Who · What · When · Before & After">Audit Trail</SectionTitle>
      <Card>
        {logs.length === 0 ? <Empty msg="No activity logged yet." /> : (
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead><tr>
              <th style={TH}>User</th><th style={TH}>Action</th><th style={TH}>Order Ref</th><th style={TH}>Before</th><th style={TH}>After</th><th style={TH}>Time</th>
            </tr></thead>
            <tbody>
              {logs.map((l, i) => (
                <tr key={i}>
                  <td style={{ ...TD, fontWeight:600 }}>{l.user_name}</td>
                  <td style={{ ...TD, fontSize:'12px' }}>{l.action}</td>
                  <td style={{ ...TD, color:T.gold, fontWeight:600, fontSize:'12px' }}>{l.order_ref||'—'}</td>
                  <td style={{ ...TD, color:T.danger, fontSize:'12px' }}>{l.before_val||'—'}</td>
                  <td style={{ ...TD, color:T.success, fontSize:'12px' }}>{l.after_val||'—'}</td>
                  <td style={{ ...TD, color:T.muted, fontSize:'11px' }}>{new Date(l.created_at).toLocaleString('en-KE')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
